export { default } from './TikTokIcon';
